export type NumberAnimationOptions = {
  duration?: number;
  reducedMotion?: boolean;
  formatter?: (value: number) => string;
};

export function animateNumber(
  element: HTMLElement,
  from: number,
  to: number,
  options: NumberAnimationOptions = {},
): void {
  const duration = Math.min(400, Math.max(0, options.duration ?? 320));
  const formatter = options.formatter ?? (value => Math.round(value).toLocaleString());
  if (options.reducedMotion || duration === 0 || from === to) {
    element.textContent = formatter(to);
    return;
  }
  const started = performance.now();
  element.classList.remove("reward-bump");
  void element.offsetWidth;
  element.classList.add("reward-bump");
  const frame = (now: number) => {
    const progress = Math.min(1, (now - started) / duration);
    const eased = 1 - Math.pow(1 - progress, 3);
    element.textContent = formatter(from + (to - from) * eased);
    if (progress < 1) requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
}
